const types = {
	SAU: 'SAU',
	CRRA: 'CRRA',
	SDIS: 'SDIS',
	EPHEMERE: 'EPHE'
}

export default types